import api from './api';

export const listProjects = api.listProjects;
export const listActivities = api.listActivities;
export const listValidations = api.listValidations;
export const listSubProjects = api.listSubProjects;
